/**
 * 工作流配置
 * @author limy
 */
import api from '@/services/api'
import {METHOD, request} from '@/utils/request'

export const dataApi = {
	async changeStatus(keyId, status) {
		let way = status ? 'active' : 'suspend';
		return request(api.workflow.WORK_FLOW_MANAGE + "/" + keyId + '/' + way, METHOD.PUT);
	},

}

export default {dataApi}